/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CompileExprSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CompileExprSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CompileExprSecurity = {
  option1?: CompileExprSecurityOption1 | undefined;
  option2?: CompileExprSecurityOption2 | undefined;
};

export type CompileExprRequest = {
  /**
   * The CEL expression to compile. Empty is valid and compiles to ok=true.
   */
  expr?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type CompileExprSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CompileExprSecurityOption1$outboundSchema: z.ZodMiniType<
  CompileExprSecurityOption1$Outbound,
  CompileExprSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function compileExprSecurityOption1ToJSON(
  compileExprSecurityOption1: CompileExprSecurityOption1,
): string {
  return JSON.stringify(
    CompileExprSecurityOption1$outboundSchema.parse(compileExprSecurityOption1),
  );
}

/** @internal */
export type CompileExprSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CompileExprSecurityOption2$outboundSchema: z.ZodMiniType<
  CompileExprSecurityOption2$Outbound,
  CompileExprSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function compileExprSecurityOption2ToJSON(
  compileExprSecurityOption2: CompileExprSecurityOption2,
): string {
  return JSON.stringify(
    CompileExprSecurityOption2$outboundSchema.parse(compileExprSecurityOption2),
  );
}

/** @internal */
export type CompileExprSecurity$Outbound = {
  Option1?: CompileExprSecurityOption1$Outbound | undefined;
  Option2?: CompileExprSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CompileExprSecurity$outboundSchema: z.ZodMiniType<
  CompileExprSecurity$Outbound,
  CompileExprSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CompileExprSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CompileExprSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function compileExprSecurityToJSON(
  compileExprSecurity: CompileExprSecurity,
): string {
  return JSON.stringify(
    CompileExprSecurity$outboundSchema.parse(compileExprSecurity),
  );
}

/** @internal */
export type CompileExprRequest$Outbound = {
  expr: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const CompileExprRequest$outboundSchema: z.ZodMiniType<
  CompileExprRequest$Outbound,
  CompileExprRequest
> = z.pipe(
  z.object({
    expr: z._default(z.string(), ""),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function compileExprRequestToJSON(
  compileExprRequest: CompileExprRequest,
): string {
  return JSON.stringify(
    CompileExprRequest$outboundSchema.parse(compileExprRequest),
  );
}
